<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div style="width:100%" v-show="organization != null">
        <v-overlay :value="loadingOverlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <div class="text-right mb-1 mt-1" style="width:100%">
            <v-btn text @click="addPremise()" class="mx-2" color="success">
                Create Premises
                <v-icon right dark>mdi-plus-circle-outline</v-icon>
            </v-btn>
            <v-btn text @click="toggleAll(true)" class="mx-2 lighten-5 green--text">
                Expand Tree
            </v-btn>
            <v-btn text @click="validate()"  class="mx-2 lighten-5 green--text">
                Validate
            </v-btn>
            <v-btn text @click="gotoIncidentHistory()" class="mx-2 lighten-5 green--text" v-if="$permissionHolder.hasPermission('FIRST_ALERT.VIEW_INCIDENTS')">
                View Incidents
            </v-btn>
        </div>
        <v-alert
            class="m-2 pt-2"
            :value="!treeItems || treeItems.length == 0"
            outlined
            color="info">
            You have No Premises Setup Yet. Start By Clicking Create Premise
        </v-alert>
        <v-alert
                class="m-2 pt-2"
                :value="treeItems && treeItems.length > 0"
                outlined
                color="info">
            For Each Item Below, You Can Click the <v-icon color="blue">mdi-menu-right</v-icon> Icon To Expand It.  Click The Name of the Item to Open A Menu.
        </v-alert>
        <v-treeview
                hoverable
                :items="treeItems"
                :open-all="true"
                :open="openItems"
        >
            <template slot-scope="{item}" slot="label">
                <v-icon>{{item.icon}}</v-icon>
                <!-- Premise Menu -->
                <v-menu bottom left v-if="item.type=='PREMISE'">
                    <template v-slot:activator="{ on }">
                        <a v-on="on" class="tree-link">{{item.name}}</a>
                    </template>
                    <v-list>
                        <v-list-item @click="sendMessage(item)">
                            <v-list-item-title>Send Announcement</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="editPremise(item)">
                            <v-list-item-title>Edit Premises</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deletePremise(item)">
                            <v-list-item-title>Delete Premises</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="addProfile(item)">
                            <v-list-item-title>Create Profile</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <!-- Profile Menu -->
                <v-menu bottom left v-if="item.type=='PROFILE'">
                    <template v-slot:activator="{ on }">
                        <a v-on="on" class="tree-link">{{item.name}}</a>
                    </template>
                    <v-list>
                        <v-list-item @click="editProfile(item)">
                            <v-list-item-title>Edit Profile</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="copyProfile(item)">
                            <v-list-item-title>Copy Profile</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deleteProfile(item)">
                            <v-list-item-title>Delete Profile</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-menu bottom left v-if="item.type=='BUTTON_FOLDER'">
                    <template v-slot:activator="{ on }">
                        <a v-on="on" class="tree-link">{{item.name}}</a>
                    </template>
                    <v-list>
                        <v-list-item @click="addButton(item)">
                            <v-list-item-title>Create New Button</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-menu bottom left v-if="item.type=='USER_FOLDER'">
                    <template v-slot:activator="{ on }">
                        <a v-on="on" class="tree-link">{{item.name}}</a>
                    </template>
                    <v-list>
                        <v-list-item @click="addUser(item)">
                            <v-list-item-title>Add User</v-list-item-title>
                        </v-list-item>

                    </v-list>
                </v-menu>
                <v-menu bottom left v-if="item.type=='BUTTON'">
                    <template v-slot:activator="{ on }">
                        <a v-on="on" class="tree-link">{{item.name}}</a>
                    </template>
                    <v-list>
                        <v-list-item @click="editButton(item)">
                            <v-list-item-title>Edit Button</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deleteButton(item)">
                            <v-list-item-title>Delete Button</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-menu bottom left v-if="item.type=='USER'">
                    <template v-slot:activator="{ on }">
                        <a v-on="on" class="tree-link">{{item.name}}</a>
                    </template>
                    <v-list>
                        <v-list-item @click="deleteUser(item.properties.recordId,item.properties.profileId)">
                            <v-list-item-title>Remove User</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-treeview>

        <v-dialog :eager="true" v-model="sendMessageDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <SendMessage ref="sendMessageDialog" @close="closeSendMesage" style="height:100%">
            </SendMessage>
        </v-dialog>
        <!-- Create Premises Dialog -->
        <v-dialog :eager="true" v-model="createPremiseDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <AddPremise :organization-id="organization.id"
                        @saved="premiseCreated"
                        ref="createPremiseDialog"
                        @cancelled="premiseCancelled"></AddPremise>
        </v-dialog>
        <!-- Edit Premise Dialog -->
        <v-dialog :eager="true" v-model="editPremiseDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <EditPremiseDetails
                        ref="editPremiseDialog"
                        @saved="premiseUpdated"
                        @cancelled="premiseUpdateCancelled"></EditPremiseDetails>
        </v-dialog>
        <!-- Create Profile Dialog -->
        <v-dialog :eager="true" v-model="createProfileDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <AddProfile
                        @saved="profileCreated"
                        ref="createProfileDialog"
                        @cancelled="profileCancelled"></AddProfile>
        </v-dialog>
        <!-- Edit Profile Dialog -->
        <v-dialog :eager="true" v-model="editProfileDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <EditProfile
                         ref="editProfileDialog"
                         @saved="profileUpdated"
                         @cancelled="cancelEditProfile"></EditProfile>
        </v-dialog>
        <!-- Create Button Dialog -->
        <v-dialog :eager="true" v-model="createButtonDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <CreateProfileButton
                                 ref="createButtonDialog"
                        @saved="buttonCreated"
                        @cancelled="buttonCancelled"></CreateProfileButton>
        </v-dialog>
        <!-- Edit button Dialog -->
        <v-dialog :eager="true" v-model="editButtonDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <EditProfileButton
                               ref="editButtonDialog"
                               @saved="buttonUpdated"
                               @cancelled="buttonCancelled"></EditProfileButton>
        </v-dialog>
        <!-- User Search Dialog -->
        <v-dialog :eager="true" v-model="searchUserDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="closeSearchUserDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Select Users</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <SearchUsers ref="userSearchDialog"
                                 :limit-to-organization="organization.id"
                                 @selected="selectUsers"
                    ></SearchUsers>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="mx-2" color="warning" outlined @click="closeSearchUserDialog()">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Copy Profile Dialog -->
        <v-dialog v-model="copyProfileDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="closeCopyProfileDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Copy Profile To Other Premises</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-alert color="info" outlined class="mt-2">
                        Select which premises you would like to copy this profile.  The profile and buttons will be duplicated for each selected premise.
                    </v-alert>
                    <v-select :items="copyPremises"
                              multiple
                              chips
                              label="Select Premise"
                              item-text="name"
                              v-model="targetPremiseIds"
                              required
                              persistent-hint
                              deletable-chips
                              append-icon="mdi-magnify"
                              item-value="id"></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="mx-2" outlined @click="doCopyProfile()" color="success">Save</v-btn>
                    <v-btn class="mx-2" color="warning" outlined @click="closeCopyProfileDialog()">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- FA Validation Dialog -->
        <v-dialog v-model="validationDialog">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="validationDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>First Alert Configuration Validations</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-alert color="info" outlined class="mt-2">
                        One or More Validations Were Found Which May Prevent Proper Usage of First Alert. Please Review Below.
                    </v-alert>
                    <v-data-table
                            :headers="validationHeaders"
                            :items="validations"
                            :items-per-page="50"
                            class="elevation-1">
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="mx-2" color="warning" outlined @click="validationDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <confirm-dialog ref="confirmDialog"></confirm-dialog>
    </div>
</template>

<script>
    import operations from '@/operations';
    import api from '@/api';
    import AddPremise from "../premise/AddPremise"
    import AddProfile from "../profile/AddProfile";
    import CreateProfileButton from "../profile_button/CreateProfileButton";
    import EditPremiseDetails from "../premise/EditPremiseDetails";
    import SearchUsers from "../user/SearchUsers";
    import EditProfileButton from "../profile_button/EditProfileButton"
    import EditProfile from "../profile/EditProfile"
    import ConfirmDialog from "@/components/common/ConfirmDialog";
    import SendMessage from "@/components/premise/SendMessage";

    export default {
        components: {
            ConfirmDialog,
            SearchUsers, EditPremiseDetails, CreateProfileButton, AddProfile, AddPremise, EditProfileButton, EditProfile, SendMessage},
        inject: ['getProvidedOrganization'],
        data() {
            return {
                loadingOverlay: false,
                organization: {
                    id: 0
                },
                treeItems : [],
                tree: [],
                openItems: [],
                flattened: {},
                createPremiseDialog : false,
                createProfileDialog : false,
                editProfileDialog   : false,
                createButtonDialog  : false,
                sendMessageDialog   : false,
                selectedPremiseId   : 0,
                selectedProfileId   : 0,
                selectedButtonId    : 0,
                editButtonDialog    : false,
                editPremiseDialog   : false,
                searchUserDialog    : false,
                copyProfileDialog   : false,
                copyPremises : [],
                targetPremiseIds     : null,
                selectedProfileIdForCopy : null,
                validations : [],
                validationDialog : false,
                validationHeaders: [
                    {'text':'Type','value':'type'},
                    {'text':'Name','value':'name'},
                    {'text':'Message','value':'message'}
                ]
            }
        },
        mounted() {
            this.organization = this.getProvidedOrganization();
            this.getTree();
        },
        methods : {
            gotoIncidentHistory() {
                this.$router.push({'path':`/organization/${this.organization.id}/incident`});
            },
            validate() {
                this.$root.$emit('showGlobalOverlay');
                api.firstAlert.validate(this.organization.id).then((data) => {
                    let results = [];
                    results = results.concat(data.errors,data.warnings,data.info);
                    this.validations = results;
                    if (this.validations.length > 0) {
                        this.validationDialog = true;
                    }
                },() => {
                    this.$root.$emit('globalError','Error Executing Validations');
                }).finally(() => {
                    this.$root.$emit('hideGlobalOverlay');
                });
            },
            toggleAll(toggle) {
                let o = [];

                function recurseItems(item) {
                    o.push(item.id);
                    if (item.children) {
                        item.children.forEach(recurseItems);
                    }
                }

                if (toggle) {
                    this.treeItems.forEach(recurseItems);
                }
                this.openItems = o;
            },
            findIdTree(id) {
                let items = [];
                let item = this.flattened[id];
                while (item) {
                    items.push(item.id);
                    if (item.properties.parentId) {
                        item = this.flattened[item.properties.parentId];
                    } else {
                        item = null;
                    }
                }
                return items;
            },
            flatten() {
                var flattened = {};

                function recurse(item) {
                    flattened[item.id] = item;
                    if (item.children) {
                        item.children.forEach((c) => {recurse(c)});
                    }
                }

                this.treeItems.forEach((treeItem) => {
                    recurse(treeItem);
                });

                this.flattened = flattened;
            },
            getTree(idToLoad) {
                this.loadingOverlay = true;
                api.firstAlert.organizationConfig(this.organization.id).then((config) =>{
                    this.treeItems = config;
                    this.flatten();
                    if (idToLoad) {
                        if (this.openItems.indexOf(idToLoad) == -1) {
                            let nodesToOpen = this.findIdTree(idToLoad);
                            if (nodesToOpen && nodesToOpen.length > 0) {
                                this.openItems = this.openItems.concat(nodesToOpen);
                            }
                        }
                    }
                    this.loadingOverlay = false;
                });
            },
            closeSendMesage () {
                this.sendMessageDialog = false;
            },
            editPremise (item) {
                this.editPremiseDialog = true;
                this.$refs.editPremiseDialog.open(Number(item.properties.recordId));
            },
            sendMessage (item) {
                this.sendMessageDialog = true;
                this.$refs.sendMessageDialog.open(Number(item.properties.recordId));
            },
            addPremise(item) {
                this.createPremiseDialog = true;
                this.$refs.createPremiseDialog.open();
            },
            premiseCreated(premise) {
                this.createPremiseDialog = false;
                this.getTree('PREMISE_'+premise.id);
                this.editPremise({
                    properties : {
                        recordId : premise.id
                    }
                });
            },
            premiseCancelled($event) {
                this.createPremiseDialog = false;
            },
            closeCopyProfileDialog() {
                this.copyProfileDialog = false;
                this.copyPremises = [];
                this.targetPremiseIds = [];
                this.selectedProfileIdForCopy = null;
            },
            async doCopyProfile() {
                this.$root.$emit('showGlobalOverlay');
                let results = await operations.massCopyProfileToOtherPremises(
                    this.selectedProfileIdForCopy,this.targetPremiseIds);
                this.$root.$emit('hideGlobalOverlay');

                let message = `Successfully Copied to ${results.success.length} Premises`;
                this.$root.$emit('globalMessage',message);
                this.closeCopyProfileDialog();
                this.getTree();
            },
            async copyProfile(item) {

                this.copyPremises = [];
                this.targetPremiseIds = [];
                this.selectedProfileIdForCopy = item.properties.recordId;

                const sourceProfileId = item.properties.recordId;
                const sourcePremiseId = item.properties.parentRecordId;
                const organizationId = this.organization.id;

                const availablePremises = await operations.getPremisesForProfileCopy(organizationId,sourcePremiseId);
                if (availablePremises.length == 0) {
                    alert("No Premises To Copy To");
                    return;
                }

                this.copyPremises = availablePremises;
                this.copyProfileDialog = true;

            },
            addProfile(item) {
                this.createProfileDialog = true;
                this.$refs.createProfileDialog.open(Number(item.properties.recordId));
            },
            profileCreated(profile) {
                this.selectedPremiseId = null;
                this.createProfileDialog = false;
                this.getTree('PROFILE_'+profile.id);
            },
            profileCancelled($event) {
                this.selectedPremiseId = null;
                this.createProfileDialog = false;
            },
            addButton(item) {
                this.$refs.createButtonDialog.open(Number(item.properties.profileId),this.organization.id);
                this.createButtonDialog = true;
            },
            buttonCreated(button) {
                this.selectedProfileId = null;
                this.createButtonDialog = false;
                this.getTree('BUTTON_'+button.id);
            },
            editButton(item) {
                this.editButtonDialog = true;
                this.$refs.editButtonDialog.open(Number(item.properties.recordId),this.organization.id);
            },
            buttonCancelled() {
                this.selectedPremiseId = null;
                this.selectedButtonId = null;
                this.createButtonDialog = false;
                this.editButtonDialog = false;
            },
            buttonUpdated() {
                this.selectedButtonId = false;
                this.editButtonDialog = false;
                this.getTree();
            },
            premiseUpdated() {
                this.selectedPremiseId = null;
                this.editPremiseDialog = false;
                this.getTree();
            },
            premiseUpdateCancelled() {
                this.selectedPremiseId = null;
                this.editPremiseDialog = false;
            },
            editProfile(item) {
                this.editProfileDialog = true;
                this.$refs.editProfileDialog.open(Number(item.properties.recordId));
            },
            cancelEditProfile() {
                this.editProfileDialog = false;
                this.selectedProfileId = null;
            },
            profileUpdated() {
                this.editProfileDialog = false;
                this.selectedProfileId = null;
                this.getTree();
            },
            doAddUser(user) {

            },
            addUser(item) {
                this.selectedProfileId = item.properties.profileId;
                this.searchUserDialog = true;
                this.$refs.userSearchDialog.open();
            },
            selectUsers(users) {
                const promises = [];
                const errorMessages = [];
                for (const key in users) {
                    promises.push(new Promise((resolve,reject) => {
                        api.profile.user.post(this.selectedProfileId, key).then(resolve,(error) => {
                            if (error.violations) {
                                errorMessages.push(error.violations[0].message);
                            }
                            resolve();
                        });
                    }));
                }
                Promise.all(promises).then(() => {
                    this.getTree('PROFILE_'+this.selectedProfileId+"_USERS");
                    this.closeSearchUserDialog();
                }).finally(() => {
                    if (errorMessages && errorMessages.length > 0) {
                        this.$root.$emit('globalError',errorMessages.join("<br/>"));
                    } else {
                        this.$root.$emit('globalMessage',"All Users Added Successfully");
                    }

                });
            },
            closeSearchUserDialog() {
                this.searchUserDialog = false;
                this.selectedProfileId = null;
            },
            deleteUser(userId,profileId) {
                this.$refs.confirmDialog.open('Remove User From Profile','Are You Sure?').then((confirm) => {
                    if (confirm) {
                        api.profile.user.del(profileId, userId).then(() => {
                            this.$root.$emit('globalMessage', 'User Removed From Profile');
                            this.getTree();
                        }, () => {

                        });
                    }
                });
            },
            deleteButton(button) {
                this.$refs.confirmDialog.open('Delete Button','Are You Sure?').then((confirm) => {
                    if (confirm) {
                        api.button.delete(button.properties.recordId).then(() => {
                            this.$root.$emit('globalMessage', 'Button Deleted');
                            this.getTree();
                        }, () => {
                            this.$root.$emit('globalError', 'Error Removing Button');
                        });
                    }
                });
            },
            deletePremise(button) {
                this.$refs.confirmDialog.open('Delete Premise','Are You Sure?').then((confirm) => {
                    if (confirm) {
                        api.premise.delete(button.properties.recordId).then(() => {
                            this.$root.$emit('globalMessage', 'Premise Deleted');
                            this.getTree();
                        }, () => {
                            this.$root.$emit('globalError', 'Error Removing Premise');
                        });
                    }
                });
            },
            deleteProfile(profile) {
                this.$refs.confirmDialog.open('Delete Profile','Are You Sure?').then((confirm) => {
                    if (confirm) {
                        api.profile.delete(profile.properties.recordId).then(() => {
                            this.$root.$emit('globalMessage', 'Profile Deleted');
                            this.getTree();
                        }, () => {
                            this.$root.$emit('globalError', 'Error Removing Profile');
                        });
                    }
                });
            }
        }
    }

</script>

<style>
    .tree-link {
        color:black !important;
        padding-left:5px;
    }
</style>